import { IOrder } from "order/model"
import { orderRPO } from "order/repository"

export const searchOrdersByName = (filter: string): Promise<IOrder[]> =>
  orderRPO.getOrders({ page: 0, pageSize: 1000 }, { name: filter })
